import { IUserPromoCode } from '../../types/user-promo-code.types';
import { USER_PROMO_CODE_ACTION } from '../action-types/user-promo-code-service.action-types';

export const saveUserPromoCodes = (data: IUserPromoCode[]) => ({
  type: USER_PROMO_CODE_ACTION.SET_USER_PROMO_CODES,
  payload: data,
});
